import React from "react";

export default function HeroImage({
  title,
  subtitle,
  imageUrl,
  children,
  className = "",
}) {
  return (
    <div className={`relative h-[280px] md:h-[380px] w-full overflow-hidden ${className}`}>
      <img
        src={imageUrl}
        alt={title}
        className="absolute inset-0 w-full h-full object-cover"
        loading="eager"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/30 to-transparent" />
      <div className="relative z-10 max-w-[1200px] mx-auto h-full flex items-end px-4 pb-6">
        <div className="text-white drop-shadow">
          <h1 className="text-2xl md:text-4xl font-bold">{title}</h1>
          {subtitle && (
            <p className="text-sm md:text-base opacity-90 mt-1">{subtitle}</p>
          )}
          {children}
        </div>
      </div>
    </div>
  );
}
